import axios from 'axios'

const state = {
  settings: [],
  settingsSingle: null,
}

const getters = {
  getSettings (state) {
    return state.settings
  },
  getSettingsSingle (state) {
    return state.settingsSingle
  },
}

const mutations = {
  setSettings (state, payload) {
    state.settings = payload
  },
  setSettingsSingle (state, payload) {
    state.settingsSingle = payload
  },
  clearSettingsSingle (state) {
    state.settingsSingle = null
  },
}

const actions = {
  fetchSettings ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/filialsSettingsList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setSettings', res.data.items)

        return res.data.items
      })
  },
  fetchSettingsSingle ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/filialsSettingsSingle'](id))
      .then((res) => {
        commit('setSettingsSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createSettings ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/filialsSettingsCreate'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  editSettings ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/filialsSettingsEdit'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  deleteSettings ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/filialsSettingsDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getSettings.filter((val) => val.id !== id)
          commit('setSettings', items)
        }

        return res
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
